<template>
  <div class="pt-4">
    <h4 class="headerTitle mt-2">
      Registrador
    </h4>

    <div class="px-2 mt-2">
      <div class="row">
        <div class="col-12 col-sm-6 col-md-5">
          <div class="form-group">
            <label class="label"
                   for="nomeDigitador">Nome do digitador</label>
            <select id="nomeDigitador"
                    v-model="registro.digitador"
                    :class="{ 'is-invalid': errors.has('nomeDigitador') }"
                    class="custom-select custom-select-sm"
                    name="nomeDigitador"
                    required
                    @change="changeData">
              <option :value="null">
                Selecione
              </option>
              <option v-for="(user, ind) in listUsers"
                      :key="ind"
                      :value="user.nome">
                {{ user.nome }}
              </option>
            </select>
            <small v-if="errors.has('nomeDigitador')"
                   class="invalid-feedback">{{ errors.first('nomeDigitador') }}</small>
          </div>
        </div>

        <div class="col-12 col-sm-5 col-md-4">
          <div class="form-group">
            <label class="label"
                   for="escrevente">Escrevente</label>
            <select id="escrevente"
                    v-model="registro.escrevente"
                    :class="{ 'is-invalid': errors.has('escrevente') }"
                    class="custom-select custom-select-sm"
                    name="escrevente"
                    :disabled="!escreventes.length"
                    @change="changeEscrevente()">
              <option v-if="!escreventes.length"
                      value="">
                Selecione
              </option>
              <option v-for="(escrevente, ind) in escreventes"
                      :key="ind"
                      :value="escrevente.nome">
                {{ escrevente.nome }}
              </option>
            </select>
            <small v-if="errors.has('escrevente')"
                   class="invalid-feedback">{{ errors.first('escrevente') }}</small>
          </div>
        </div>

        <div class="col-12 col-sm-4 col-md-3 col-xl-2">
          <div class="form-group">
            <label class="label"
                   for="dataRegistro">Data do Registro</label>
            <input id="dataRegistro"
                   v-model="registro.data_registro"
                   v-mask="'##/##/####'"
                   v-validate="`required|date_format:dd/MM/yyyy|date_between:${initDate},${limitDate}`"
                   :class="{ 'is-invalid': errors.has('date') }"
                   class="form-control form-control-sm"
                   maxlength="10"
                   name="date"
                   placeholder="00/00/0000"
                   required
                   type="text"
                   @change="changeData">
            <small v-if="errors.has('date')"
                   class="invalid-feedback">{{ errors.first('date') }}</small>
          </div>
        </div>
      </div>
    </div>

    <h4 class="headerTitle mt-2">
      Registro
    </h4>

    <div class="px-2 mt-2">
      <div class="form-group">
        <span class="custom-control custom-radio custom-control-inline">
          <input id="primeiraViaRegistro"
                 v-model="localData.tipoRegistro"
                 class="custom-control-input"
                 checked
                 name="registro"
                 type="radio"
                 value="primeiro"
                 @change="setTipoRegistro">
          <label class="custom-control-label"
                 for="primeiraViaRegistro">1ª via</label>
        </span>

        <span class="custom-control custom-radio custom-control-inline">
          <input id="legadoRegistro"
                 v-model="localData.tipoRegistro"
                 class="custom-control-input"
                 name="registro"
                 value="legado"
                 type="radio"
                 @change="setTipoRegistro">
          <label class="custom-control-label"
                 for="legadoRegistro">Legado</label>
        </span>
      </div>

      <div class="row">
        <div v-if="(localData.tipoRegistro === 'legado')"
             class="col-12 col-sm-3 col-md-2">
          <div class="form-group">
            <label class="label"
                   for="AcervoRegistro">Acervo</label>
            <select id="AcervoRegistro"
                    v-model="registro.acervo"
                    class="custom-select custom-select-sm"
                    :disabled="localData.tipoRegistro === 'primeiro'"
                    name="AcervoRegistro"
                    @change="changeData">
              <option :value="1">
                01
              </option>
              <option :value="2">
                02
              </option>
            </select>
          </div>
        </div>
        <div v-if="(localData.tipoRegistro === 'legado')"
             class="col-12 col-sm-2">
          <div class="form-group">
            <label class="label"
                   for="livroRegistro">Livro</label>
            <input id="livroRegistro"
                   v-model="registro.livro"
                   class="form-control form-control-sm"
                   :disabled="localData.tipoRegistro === 'primeiro'"
                   name="livroRegistro"
                   placeholder="00000"
                   type="number"
                   @change="changeData">
          </div>
        </div>

        <div v-if="(localData.tipoRegistro === 'legado')"
             class="col-12 col-sm-2">
          <div class="form-group">
            <label class="label"
                   for="folhaRegistro">Folha</label>
            <input id="folhaRegistro"
                   v-model="registro.folha"
                   class="form-control form-control-sm"
                   :disabled="localData.tipoRegistro === 'primeiro'"
                   name="livroRegistro"
                   placeholder="000"
                   type="number"
                   @change="changeData">
          </div>
        </div>

        <div v-if="(localData.tipoRegistro === 'legado')"
             class="col-12 col-sm-3">
          <div class="form-group">
            <label class="label"
                   for="termoRegistro">Registro</label>
            <input id="termoRegistro"
                   v-model="registro.termo"
                   class="form-control form-control-sm"
                   :disabled="localData.tipoRegistro === 'primeiro'"
                   name="termoRegistro"
                   placeholder="0000000"
                   type="number"
                   @change="changeData">
          </div>
        </div>

        <div v-if="(localData.tipoRegistro === 'legado')"
             class="col-12 col-sm-3 col-md-2">
          <div class="form-group">
            <label class="label"
                   for="ladoRegistro">Lado</label>
            <select id="ladoRegistro"
                    v-model="registro.lado"
                    class="custom-select custom-select-sm"
                    :disabled="localData.tipoRegistro === 'primeiro'"
                    name="ladoRegistro"
                    @change="changeData">
              <option :value="`FRENTE`">
                Frente
              </option>
              <option :value="`VERSO`">
                Verso
              </option>
            </select>
          </div>
        </div>

        <div v-if="localData.tipoRegistro"
             :class="{ 'mt-lg-3 pt-lg-3': (localData.tipoRegistro === 'legado') }"
             class="col-auto">
          <div class="form-group pb-sm-1">
            <span class="custom-control custom-switch custom-control-inline">
              <input id="registros"
                     v-model="registro.dentro_prazo"
                     class="custom-control-input"
                     checked
                     name="registros"
                     type="checkbox"
                     @change="changeData"
                     @keyup.enter="changePrazo">
              <label class="custom-control-label"
                     for="registros">Registro no prazo</label>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { document } from '@/utils/nascObject'
  import Swal from 'sweetalert2'
  import objSwal from '@/constants/swalValues'
  import { mapGetters } from 'vuex'
  import moment from "moment"

  /* services */
  import UsuarioService from '@/services/Auth/UsuarioService'
  import NascimentoService from "@/services/Registros/Nascimento"

  export default {
    name: 'PassoRegistro',
    inject: ['$validator'],
    props: {
      propCartorio: { type: Object, default: () => ({})},
      propData: { type: Object, default: () => ({})}
    },
    data () {
      return {
        document,
        dataObj: {},
        registro: {
          oficial: '',
          digitador: '',
          escrevente: '',
          dentro_prazo: true,
          data_registro: '',
          lado: 'FRENTE',
          origem: '',
          cargo_escrevente: ''
        },
        escreventes: [],
        sequenciaLivro: {},
        localData: {},
        listUsers: [],
        initDate: '01/01/1500',
        limitDate: moment(new Date()).add(1, 'day').format('DD/MM/YYYY'),
      }
    },
    computed: {
      ...mapGetters({
        user: 'auth/getUser',
        cartorioId: 'auth/getCartorioId',
      })
    },
    watch: {
      propCartorio () {
        if (this.propCartorio.nome_oficial) {
          this.registro.oficial = this.propCartorio.nome_oficial
        }
      }
    },

    mounted () {
      this.getusersList()
      this.checkData()
      this.init()
    },
    methods: {
      init () {
        if (Object.values(this.propData).length) {
          this.initDate = moment(this.propData.registro.pessoa.data_nascimento).add(-1, 'day').format('DD/MM/YYYY')
        }
      },
      async getusersList () {
        try {
          await UsuarioService.getUsuarios().then(res => { this.listUsers = res.data })
        } catch (e) {
          return this.getAnError(e)
        }
        await this.loadEscreventes()
      },
      async loadEscreventes () {
        const response = await UsuarioService.getUsuarios()
        if (!response || !response.data) return

        this.escreventes = []
        let usuarios = response.data || []
        this.escreventes = usuarios.filter(usuario => usuario.escrevente === 1 )
      },
      async setTipoRegistro () {
        if (!this.localData.tipoRegistro) { return }

        if (this.localData.tipoRegistro === 'primeiro') {
          this.registro.origem = 'novo'
        } else {
          this.registro.matricula = ''
          this.registro.livro_id = null
          this.registro.folha = null
          this.registro.livro = null
          this.registro.termo = null
          this.registro.acervo = 1 // trazemos como sugestão o acervo = 1
          this.registro.lado = 'FRENTE'
          this.registro.origem = 'legado'
          this.sequenciaLivro = null
        }

        this.changeData()
      },
      changeData () {
        this.$validator.validateAll().then((resp) => {
          if (!resp) return
          return this.updateDataPassoNascido()
        })
      },
      mountObjRetorno (val) {
        this.document = val.document
        this.registro = {
          rascunho_id: this.$route.params.idNasc,
          ...val.document.registro,
          data_registro: moment((val.document.registro.data_registro ? val.document.registro.data_registro : new Date())).format('DD/MM/YYYY')
        }

        this.localData.tipoRegistro = val.document.registro.primeiraVia

        if (!this.registro.digitador) {
          this.registro.digitador = this.user.nome
        }
        this.registro.escrevente = this.user.nome
        this.registro.cargo_escrevente = this.user.cargo
        this.registro.oficial = this.propCartorio.nome_oficial

        // Pré-seleciona o radio button da 1ª via
        this.localData.tipoRegistro = 'primeiro'
        this.registro.origem = 'novo'

        this.changeData()
      },
      mountObj () {
        return {
          registro: {
            ...this.document.registro,
            ...this.registro,
            rascunho_id: this.$route.params.idNasc,
            data_registro: moment(this.registro.data_registro, 'DD/MM/YYYY').format('YYYY-MM-DD'),
            primeiraVia: this.localData.tipoRegistro,
            tipo_registro: 'N',
            num_livro: this.registro.livro
          },
          sequenciaLivro: {
            ...this.sequenciaLivro
          },
          // Partes cadastradas no primeiro e segundo passo
          recem_nascido: this.document.recem_nascido,
          nascimento_informacao: this.document.nascimento_informacao,
          gemeos: this.document.gemeos,
          local: this.document.local,
          ordem_nascimento: this.document.ordem_nascimento
        }
      },
      // API's
      async updateDataPassoNascido () {
        let { idNasc } = this.$route.params
        loader({ text: 'Atualizando dados dados...', active: true })

        try {
          await NascimentoService.updateNascimentoRasc(idNasc, { document: this.mountObj() }).then(result => {
            loader({ text: '', active: false })
            return this.sendDataToContainer()
          })
        } catch (e) {
          return this.getAnError(e.message)
        }
      },
      async checkData () {
        let { idNasc } = this.$route.params

        if (idNasc === 'novo') return
        loader({ text: 'Buscando dados...', active: true })

        try {
          await NascimentoService.getNascimentoRascById(idNasc).then(val => {
            this.dataObj = val
            this.mountObjRetorno(val)
            return this.sendDataToContainer()
          })
        } catch (e) {
          this.getAnError(e.message).then(error => {
            this.$router.push({ name: 'cadastro_nascimento', params: { idNasc: 'novo' } })
          })
        }
      },
      getAnError (text) {
        loader({ text: '', active: false })

        objSwal.error.title = 'Erro ao cadastrar'
        objSwal.error.text = text || 'Houve algum erro ao cadastrar um novo registro de nascimento, favor contactar o suporte'
        return Swal.fire(objSwal.error).then(result => loader({ text: '', active: false }))
      },
      sendDataToContainer (val) {
        loader({ text: '', active: false })
        return this.$emit('receiveData', val ? val : this.mountObj())
      },
      changePrazo () {
        setTimeout(() => {
          this.registro.dentro_prazo = !this.registro.dentro_prazo

          this.changeData()
        }, 200)
      },
      changeEscrevente () {
        if (this.registro.escrevente) {
          const selectEscreventes = window.document.getElementById('escrevente')
          this.registro.cargo_escrevente  = this.escreventes[selectEscreventes.selectedIndex].cargo
        }
        this.changeData()

      }
    },
  }
</script>

<style lang="scss">
  @import '../../../../../scss/_utilities/_exports';

  .headerTitle {
    @extend %titleBox--sm;
    background-color: $color-gray-light;
  }
</style>
